let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("iVrNz")]).then(() => parcelRequire('cENCg'));